export enum ControlType {
  Select,
  Number,
  Checkbox,
  Currency
}
